import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from "src/environments/environment";
import { Observable } from 'rxjs';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';


@Injectable({
  providedIn: "root"
})
export class ReportingService {
  constructor(
    private http: HttpClient,
    private _restClientService: RestClientService
  ) {}

  exportDossiersACorriger(
    debut: String,
    fin: String,
    workflow: String
  ): Observable<Blob> {
    const downloadUrl =
      environment.BACKEND_RACINE_URL +
      "reporting/export-dossiers-a-corriger?debut=" +
      debut +
      "&fin=" +
      fin +
      "&workflow=" +
      workflow;

    const options = {
      responseType: "blob" as "json"
    };

    return this.http.get<any>(downloadUrl, options);
  }

  exportDossiersAll(
    debut: String,
    fin: String,
    workflow: String
  ): Observable<Blob> {
    const downloadUrl =
      environment.BACKEND_RACINE_URL +
      "reporting/export-dossiers-all?debut=" +
      debut +
      "&fin=" +
      fin +
      "&workflow=" +
      workflow;

    const options = {
      responseType: "blob" as "json"
    };

    return this.http.get<any>(downloadUrl, options);
  }

  exportDossiersParGestionnaire(
    debut: String,
    fin: String,
    workflow: String,
    statut: String
  ): Observable<Blob> {
    const downloadUrl =
      environment.BACKEND_RACINE_URL +
      "reporting/export-dossiers-par-gestionnaire?debut=" +
      debut +
      "&fin=" +
      fin +
      "&statut=" +
      statut +
      "&workflow=" +
      workflow;
    const options = {
      responseType: "blob" as "json"
    };

    return this.http.get<any>(downloadUrl, options);
  }

  exportRequestsHistoryByWorkflowAndUsername(
    workflow,
    filter,
    username,
    status,
    debut,
    fin
  ): Observable<Blob> {
    const downloadUrl =
      environment.BACKEND_RACINE_URL +
      "reporting/export-requests-history-by-workflow-and-username" +
      "?workflow=" +
      workflow +
      "&filter=" +
      filter +
      "&username=" +
      username +
      "&status=" +
      status +
      "&debut=" +
      debut +
      "&fin=" +
      fin;

    const options = {
      responseType: "blob" as "json"
    };

    return this.http.get<any>(downloadUrl, options);
  }

  exportRequestsHistoryByInitiateur(
    workflow,
    filter,
    username,
    status,
    debut,
    fin
  ): Observable<Blob> {
    const downloadUrl =
      environment.BACKEND_RACINE_URL +
      "reporting/export-requests-history-by-initiateur" +
      "?workflow=" +
      workflow +
      "&filter=" +
      filter +
      "&username=" +
      username +
      "&status=" +
      status +
      "&debut=" +
      debut +
      "&fin=" +
      fin;

    const options = {
      responseType: "blob" as "json"
    };

    return this.http.get<any>(downloadUrl, options);
  }
}